import { RequestStatus } from 'types';

export enum AuthStorageItems {
  Token = 'userAddress',
}

export interface AuthStorage {
  userAddress: string;
}

const authUtil = {
  getAuthFromStorage: () => {
    const userAddress = localStorage.getItem(AuthStorageItems.Token) || '';

    if (!userAddress) {
      return {
        userAddress: '',
        authStatus: RequestStatus.None,
      };
    }

    return {
      userAddress,
      authStatus: RequestStatus.Success,
    };
  },

  setAuthToStorage: (params: AuthStorage) => {
    localStorage.setItem(AuthStorageItems.Token, String(params.userAddress));
  },
};

export default authUtil;
